import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class RoutesService {
    token = localStorage.getItem('token');
    options = {
        headers: new HttpHeaders({
            // tslint:disable-next-line:object-literal-key-quotes
            'Authorization': `Bearer ${this.token}`
        })
    };

    constructor(private http: HttpClient) { }
    private _clearStudentData = new BehaviorSubject<boolean>(false);
    clearStudentData = this._clearStudentData.asObservable();


    clearAllStudents() {
        this._clearStudentData.next(true);
    }

    getClearAllStudents() {
        return this._clearStudentData;
    }

    private _clearSingleStudentData = new BehaviorSubject<any>(null);
    clearSingleStudentData = this._clearSingleStudentData.asObservable();


    clearSingleStudentFunc(obj) {
        this._clearSingleStudentData.next(obj);
    }

    getClearSingleStudent() {
        return this._clearSingleStudentData;
    }

    private _checkAllBtn = new BehaviorSubject<boolean>(null);
    checkAllBtn = this._checkAllBtn.asObservable();

    disableCheckAllBtn() {
        this._checkAllBtn.next(false);
    }

    getCheckAllBtn() {
        return this._checkAllBtn;
    }

    createRoute(body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/routes`, body);
    }

    getUnassignedDrivers() {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users/drivers`);
    }

    getUnassignedForRole(role) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users/unassigned?role=${role}`)
    }

    getSupervisors() {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users?role_type=supervisor&is_paginated=0`)
    }

    deleteRoutes(body) {
        let options = this.options;
        options['body'] = body;
        return this.http.delete(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/routes/delete`, options);
    }

    getAllRoutes(pageSize, sortby, sortOrder, search, pageNumber, filterValues, paginated = 1) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/routes?is_paginated=${paginated}&per_page=${pageSize}&sort[${sortby}]=${sortOrder}&search=${search}&page=${pageNumber}${this.getFilterString(filterValues)}`)
    }

    getStudentsJoinedBusesSystem(sortBy, sortValue, searchValue, filterValues) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}
        /students/routes/join?is_paginated=0&filter[is_joined]=1&filter[route]=without_route&sort[${sortBy}]=${sortValue}
        &search=${searchValue}
        &${this.getFilterString(filterValues)}`)
    }

    getFilterString(filterValues) {
        let filterValuesForGradesApi = '';
        let filterValuesForClassesApi = '';

        if (filterValues) {
            if (filterValues.grades !== undefined) {
                filterValues.grades.map((filterValue: string) => {
                    filterValuesForGradesApi = filterValuesForGradesApi.concat('&filter[grade_id][]=' + filterValue)
                })
            }
            if (filterValues.classes !== undefined) {
                filterValues.classes.map((filterValue: string) => {
                    filterValuesForClassesApi = filterValuesForClassesApi.concat('&filter[class_id][]=' + filterValue)
                })
            }
        }
        return filterValuesForGradesApi + filterValuesForClassesApi;
    }

    assignStudentsToRoute(body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/routes/students`, body)
    }

    assignStudentsOrdering(body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/routes/parents`, body)
    }
    getSingleRoute(routeId) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/routes/${routeId}`);
    }
    getParentsOrder(routeId) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/routes/${routeId}/parents`);
    }

    updateSingleRoute(routeId, body) {
        return this.http.put(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/routes/${routeId}`, body)
    }

    getStaff(role) {
        return this.http.get(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users?role_type=staff&is_paginated=0&filter[role][]=${role}`)
    }
}